import { defineComponent as _defineComponent } from 'vue'

import { defineComponent, useRoute } from "@nuxtjs/composition-api";

import AppDownload1x from "@/assets/images/app-download/1x.jpg";
import AppDownload2x from "@/assets/images/app-download/2x.jpg";
import AppDownload3x from "@/assets/images/app-download/3x.jpg";
import AppDownload4x from "@/assets/images/app-download/4x.jpg";
import { useAmplitude } from "@/composables";

const __default__ = defineComponent({
  name: "AppDownload",
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  maxHeight: {
    type: [String, Number],
    default: undefined,
  },
  shaped: {
    type: Boolean,
    default: true,
  },
  showContinueLink: {
    type: Boolean,
    default: false,
  },
},
  emits: ["app-download-screen-close", "app-download-screen-download-click"],
  setup(__props, { emit: emits }: { emit: ({
  (e: "app-download-screen-close"): void;
  (e: "app-download-screen-download-click"): void;
}), expose: any, slots: any, attrs: any }) {





const amplitude = useAmplitude();
const route = useRoute();

const onAppDownloadScreenClose = () => {
  amplitude?.sendEvent("/dismiss-web-vpm", {
    "vpm-type": route.value.name === "index" ? "app download drawer" : "app download prompt screen",
  });
  emits("app-download-screen-close");
};

const onDownloadClick = () => {
  amplitude?.sendDownloadAppEvent(route.value.name === "index" ? "app download vpm" : "app download prompt screen");
  emits("app-download-screen-download-click");
};

return { __sfc: true,emits, amplitude, route, onAppDownloadScreenClose, onDownloadClick, AppDownload1x, AppDownload2x, AppDownload3x, AppDownload4x }
}

})